import { Fragment } from 'react';

import { ListCacheManager } from '@/data/hook/query/v2/CacheFacade';
import ScheduledLessonReportView from './ScheduledLessonReportView';
import { ReportScheduleLessonHeader } from '../ReportScheduleLessonHeader';
import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';

type ScheduledLessonReportModalContentProps = {
  klass: Klass | undefined;
  scheduledLesson: ScheduledLesson | undefined;
  onClose: () => void;
  cacheManager?: ListCacheManager<ScheduledLesson>;
};

export default function ScheduledLessonReportModalContent({
  klass,
  scheduledLesson,
  onClose,
  cacheManager,
}: ScheduledLessonReportModalContentProps) {
  if (!klass || !scheduledLesson) return <Fragment />;

  return (
    <>
      <ReportScheduleLessonHeader
        scheduledLesson={scheduledLesson}
        klassDuration={klass.duration}
      />

      <ScheduledLessonReportView
        klass={klass}
        scheduledLesson={scheduledLesson}
        onClose={onClose}
        cacheManager={cacheManager}
      />
    </>
  );
}
